import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Money } from '../../../../Money';
import { SanitizedOrder } from '../../../../../types/order/Order';

interface OrderAmountPaidProps {
  order: SanitizedOrder;
}

const OrderAmountPaid = ({
  order,
}: OrderAmountPaidProps) => {
  const { totalDetails } = order;

  return (
    <div className="pd-flex pd-gap-4">
      <div className="pd-grow pd-font-bold">
        <FormattedMessage
          id="account.order.payment.paid"
          defaultMessage="Amount paid"
        />
      </div>
      <div>
        <Money value={totalDetails.paidAmount.centAmount} />
      </div>
    </div>
  );
};

export default OrderAmountPaid;
